export enum AdminPermissionDomain {
  Superior = 'Superior',
  Business = 'Business',
  Genetics = 'FeaturesAndGenetics',
  BusinessPortal = 'BusinessPortal',
}
